import { Tooltip } from "@material-tailwind/react";
import { ReactComponent as EditPencil } from "../../Assets/Svg/EditPencil.svg";
import { useState } from "react";
import { useWorkspaceStore } from "../../Context/store";
import EditSubDebatePopup from "../../Components/Popup/EditSubDebatePopup";

const WorkspaceTitle = () => {
  const [openEditWorkspace, setEditWorkspacePopup] = useState(false);
  const { selectedWorkspace } = useWorkspaceStore();
  return (
    <div className="flex w-full">
      <div className="flex p-0 gap-2 justify-between w-full items-center font-normal capitalize tracking-normal hover:bg-transparent active:bg-transparent">
        <span className="flex-1 xs:line-clamp-1 w-full text-lg text-left text-secondary font-semibold md:text-debatePalette-background">
          {selectedWorkspace?.WorkSpaceName || selectedWorkspace?.workSpaceName}
        </span>
        <Tooltip content="Edit debatebase">
          <EditPencil
            className="h-6 w-6 text-secondary md:text-white cursor-pointer hover:text-debatePalette-buttonBorder"
            onClick={(e) => {
              e.stopPropagation();
              setEditWorkspacePopup(true);
            }}
          />
        </Tooltip>
      </div>
      <EditSubDebatePopup
        popupFor="workspace"
        open={openEditWorkspace}
        handleClose={() => setEditWorkspacePopup(false)}
      />
    </div>
  );
};

export default WorkspaceTitle;
